import React, { useState } from "react";
import "./ExternalCostsModule.scss";

// Lazy Imports um Bundle-Größe zu reduzieren und Fehler zu isolieren
const ExternalCostsOverview = React.lazy(() => import("./ExternalCostsOverview"));
const ProvidersConfig = React.lazy(() => import("./ProvidersConfig"));
const DomainsOverview = React.lazy(() => import("./DomainsOverview"));
const CustomersOverview = React.lazy(() => import("./CustomersOverview"));
const MappingsManager = React.lazy(() => import("./MappingsManager"));
const ProductPriceManager = React.lazy(() => import("./ProductPriceManager"));
const DomainBilling = React.lazy(() => import("./DomainBilling"));
const InvoicesOverview = React.lazy(() => import("./InvoicesOverview"));
const ManualReview = React.lazy(() => import("./ManualReview"));
const AdminPanel = React.lazy(() => import("./AdminPanel"));

const ExternalCostsModule = () => {
    const [activeTab, setActiveTab] = useState('overview');
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    const menuGroups = [
        {
            title: 'Übersicht',
            items: [
                { id: 'overview', label: 'Transaktionen', icon: '📋' },
                { id: 'review', label: 'Manuelle Prüfung', icon: '🔍', badge: true },
            ]
        },
        {
            title: 'Abrechnung',
            items: [
                { id: 'billing', label: 'Abrechnen', icon: '🧾' },
                { id: 'invoices', label: 'Rechnungen', icon: '📄' },
            ]
        },
        {
            title: 'Daten',
            items: [
                { id: 'customers', label: 'Kunden', icon: '👥' },
                { id: 'domains', label: 'Domains', icon: '🌐' },
            ]
        },
        {
            title: 'Konfiguration',
            items: [
                { id: 'mappings', label: 'Zuordnungen', icon: '🔗' },
                { id: 'prices', label: 'Produkte', icon: '📦' },
                { id: 'providers', label: 'Provider', icon: '⚙️' },
                { id: 'admin', label: 'Admin', icon: '🛠️' },
            ]
        }
    ];

    return (
        <div className={`external-costs-module with-sidebar ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
            {/* Sidebar Navigation - Things 3 Style */}
            <nav className="module-sidebar">
                <div className="sidebar-header">
                    <h1 className="sidebar-title">Externe Kosten</h1>
                    <button 
                        className="collapse-btn"
                        onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                        title={sidebarCollapsed ? 'Sidebar einblenden' : 'Sidebar ausblenden'}
                    >
                        {sidebarCollapsed ? '→' : '←'}
                    </button>
                </div>

                <div className="sidebar-menu">
                    {menuGroups.map((group, groupIndex) => (
                        <div key={groupIndex} className="menu-group">
                            <div className="menu-group-title">{group.title}</div>
                            {group.items.map(item => (
                                <button
                                    key={item.id}
                                    className={`menu-item ${activeTab === item.id ? 'active' : ''}`}
                                    onClick={() => setActiveTab(item.id)}
                                >
                                    <span className="menu-icon">{item.icon}</span>
                                    <span className="menu-label">{item.label}</span>
                                    {item.badge && <span className="menu-badge">!</span>}
                                </button>
                            ))}
                        </div>
                    ))}
                </div>
            </nav>

            {/* Main Content */}
            <div className="module-content">
                <React.Suspense fallback={<div className="content-loading">Lade...</div>}>
                    {activeTab === 'overview' && <ExternalCostsOverview />}
                    {activeTab === 'review' && <ManualReview />}
                    {activeTab === 'billing' && <DomainBilling />}
                    {activeTab === 'invoices' && <InvoicesOverview />}
                    {activeTab === 'customers' && <CustomersOverview />}
                    {activeTab === 'domains' && <DomainsOverview />}
                    {activeTab === 'prices' && <ProductPriceManager />}
                    {activeTab === 'providers' && <ProvidersConfig />}
                    {activeTab === 'mappings' && <MappingsManager />}
                    {activeTab === 'admin' && <AdminPanel />}
                </React.Suspense>
            </div>
        </div>
    );
};

export default ExternalCostsModule;
